import { CardContent, Typography } from "@mui/material";
import { MprcCard } from "components";
import { MprcContainer } from "components/MprcContainer";
import { MprcRecordInfo } from "components/MprcRecordInfo";
import { AuditLogEntityType } from "generated/CoreApi_v1";
import { Formaters } from "lib/Formaters";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { AuditLogDialog } from "views/common/AuditLog/AuditLogDialog";
import { RecordInfoUser } from "./EditUser";

////////////////////////////////////////////////////////////////////////////

interface IProps {
    userId: string;
    name: string;
    recordInfo: RecordInfoUser;
}

////////////////////////////////////////////////////////////////////////////

export const EditUserFooter: React.FC<IProps> = ({ userId, name, recordInfo }) => {

    const { t } = useTranslation();
    const [dialog, setDialog] = useState<any>(null);

    return (
        <MprcContainer>
            {dialog}
            <MprcCard>
                <CardContent>
                    <MprcRecordInfo recordInfo={recordInfo}
                        onHistoryClick={
                            () => {
                                setDialog(
                                    <AuditLogDialog
                                        title={name}
                                        entityType={AuditLogEntityType.User}
                                        entityKey={[userId]}
                                        onClose={() => setDialog(null)}
                                    />
                                );
                            }
                        }
                    >
                        {recordInfo.lastLoginOn &&
                            <Typography component="p" variant="h6">
                                {t("User.Edit.LastLoginText")} {Formaters.relativeCalendar(recordInfo.lastLoginOn!)}
                            </Typography>
                        }
                    </MprcRecordInfo>
                </CardContent>
            </MprcCard>
        </MprcContainer>
    );
};
